export default __webpack_public_path__ + "static/media/mena12.3683cb90.jpg";